import React, {Component} from 'react'
import { connect } from 'react-redux'

import { FILE_STORAGE_API } from '../../../constants'

// import styles
import './index.scss'

// import components
import Modal from '../../components/Modal'

// import actions
import { getMultipleShopPunchTimeReport } from '../../../actions/punchclock'

// Util
import { translation } from '../../../utils/helpers'

// Elements
import Check from '../../elements/check'

import { ModalIcons } from '../../elements/icons'

class PunchReportModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      employees: []
    }

    this.downloadPDF = this.downloadPDF.bind(this)
    this.renderSelectAll = this.renderSelectAll.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount () {
    this.getEmployees(this.props)
  }

  getEmployees (props) {
    let employeeList = props.employees.filter((employee) => {
      return employee.Active ? employee : false
    })
    let employees = []
    employeeList.map((employee) => {
      employees.push({
        id: employee.UserId,
        name: employee.Name,
        checked: false
      })
    })
    this.setState({
      employees: employees
    })
  }

  onClose () {
    this.props.onClose()
  }

  downloadPDF (e) {
    e.preventDefault()

    // Generate employee list
    let employeeList = []
    this.state.employees.map((employee) => {
      if (employee.checked === true) {
        employeeList.push(employee.id)
      }
    })

    // Data
    let data = {
      FromTime: this.props.From.format('YYYY-MM-DD'),
      ToTime: this.props.To.format('YYYY-MM-DD'),
      Employees: employeeList
    }

    // Loading ON
    this.refs.modal.isLoading(true)

    // Call API
    this.props.getMultipleShopPunchTimeReport(data).then((res) => {
      // Loading OFF
      this.refs.modal.isLoading(false)
      // FileURL
      let downloadURL = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + res.data.FileURL + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      // Open file in new window
      let win = window.open(downloadURL, '_blank')

      if (win.focus !== undefined) {
        win.focus()
      }
      // Close modal
      this.props.onClose()
    }, () => {
      // Loading OFF
      this.refs.modal.isLoading(false)
      // Error message
      window.toastr.error(translation('2239'), translation('216'))
    })
  }

  renderList () {
    // Render employee
    const renderEmployee = (employee, key) => {
      const onChange = (e) => {
        let employees = this.state.employees
        employees.map((item) => {
          if (item.id === employee.id) {
            item.checked = !employee.checked
          }
        })
        this.setState({
          employees: employees
        })
      }
      return (
        <Check key={key} ref={'employee_' + employee.id} id={employee.id + '_checkbox'} onChange={onChange} value={employee.id} checked={employee.checked} labelText={employee.name} />
      )
    }
    // Return
    return (
      <ul>
        {this.state.employees.map(renderEmployee)}
      </ul>
    )
  }

  renderDates () {
    let fromDate = this.props.From.format('DD-MM-YYYY')
    let toDate = this.props.To.format('DD-MM-YYYY')
    return (
      <div className='punch_dates'>
        <span>{translation('188')}:</span> {fromDate}<br />
        <span>{translation('187')}:</span> {toDate}
      </div>
    )
  }

  renderSelectAll () {
    const changeSelectAll = (e) => {
      let value = e.target.checked
      let employees = this.state.employees
      employees.map((employee) => {
        employee.checked = value
      })
      this.setState({
        employees: employees
      })
    }

    return (
      <Check ref='select_all' id={'all_checkbox'} onChange={changeSelectAll} labelText={translation('531')} />
    )
  }

  render () {
    return (
      <div className='punchreport__modal'>
        <Modal
          ref='modal'
          {...this.props}
          header={translation('2159')}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose
          onClose={this.onClose}
          icon={ModalIcons.Plus}
          bottomBarProps={{
            actionLabelText: translation('2238'),
            onActionClick: this.downloadPDF
          }}
        >
          {this.renderDates()}
          {this.renderSelectAll()}
          {this.renderList()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  getMultipleShopPunchTimeReport
})(PunchReportModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PunchReportModal/index.js